import * as Yup from 'yup';
import { NUMBER_REGEX } from '../../../constants';

export const pricePriceValidationSchema = Yup.object({
  price: Yup.string().matches(NUMBER_REGEX, 'Il prezzo deve essere un valore numerico intero'),
});
